<template>
  <div class="post">
    <!-- header -->
    <div class="post_header">
      <!-- title -->
      <div class="card card-body pb-0" style="border-radius: 10px">
        <table class="table" width="100%">
          <tr>
            <td><strong>Title</strong></td>
            <td>{{ caseStudy.title || "title" }}</td>
          </tr>

          <tr>
            <td><strong>Published</strong></td>
            <td>{{ caseStudy.published === 1 ? "Yes" : "No" }}</td>
          </tr>
          <tr>
            <td><strong>Featured</strong></td>
            <td>
              <span>{{ caseStudy.featured === 1 ? "Yes" : "No" }}</span>
            </td>
          </tr>
          <tr>
            <td><strong>Slug</strong></td>
            <td>
              <span>{{ caseStudy.slug || "" }}</span>
            </td>
          </tr>

        </table>
      </div>
      <span class="clearfix d-block mb-3"></span>
    </div>
  </div>
</template>

<script>

import postComment from "./caset_study_comment";
import helpers from "@/helpers";

export default {
  components: {
    postComment,
  },

  data: function (){
    return {
      product: localStorage.getItem('product')
    };
  },

  computed: {
    caseStudy: function () {
      return this.$store.getters["caseStudy/caseStudy"];
    },

    comments: function () {
      return this.$store.getters["comments/comments"];
    },

    caption: function () {
      if (!!this.post.caption && this.post.caption != "undefined") {
        return this.$baseURL + "/storage/posts/captions/" + this.post.caption;
      } else return this.$baseURL + "/images/default.jpg";
    },

    body: function () {
      if (!this.post.body) {
        return this.post.body.replace(
            /"posts\/images\/.*?\.png/g,
            (imagePath) => {
              return '"' + this.$baseURL + "/storage/" + imagePath.substr(1);
            }
        );
      }
      return "";
    },

  },


  created() {
    this.page = helpers.getPageQuery();
    this.$store.dispatch('caseStudy/view', this.$route.params.slug)
  },
  methods: {

  },
};
</script>
